'use strict';

/**
 * @author Maxim Seredkin
 */

export default ['$scope', '$routeParams', '$window', 'OwnershipFormService',
                function($scope, $routeParams, $window, OwnershipFormService) {
                    $scope.ownershipForms = [];
                    OwnershipFormService.api.get({
                                           filters: [`'status' EQ 'ENABLED'`],
                                           sorts: ['name:ASC'],
                                       }, (data) => $scope.ownershipForms = data._embedded);
                }];
